import React from "react";
import dummyimage from "../../images/picture.svg";
import moment from "moment";

const ReviewPublish = (props) => {
  var foundCategory = props?.categoriesData?.type_of_attractions.find(function (
    category
  ) {
    return category?.name === props?.data?.categories;
  });

  return (
    <div className="review-list-cover">
      <div className="title">
        <h3>Review</h3>
        <p>Please review your attraction</p>
      </div>
      <div className="review-row">
        <div className="review-col-left">
          <div className="review-image">
            <img
              src={props?.data?.image_url ? props?.data?.image_url : dummyimage}
              alt="review images"
            />
          </div>
        </div>
        <div className="review-col-right">
          {/* <label>{props?.data?.categories ? props?.data?.categories : ''}</label> */}
          <label>{foundCategory?.name ? foundCategory?.name : ""}</label>
          <h2>{props?.data?.name ? props?.data?.name : ""}</h2>
          <p style={{ overflowWrap: "break-word", inlineSize: "500px" }}>
            {props?.data?.description ? props?.data?.description : ""}
          </p>
          <div className="ticket-content">
            {/* <label>Open</label>
            <p>
              Mon- Sun <span>9:30 AM - 4:30 PM</span>
            </p> */}
            {props
              ? props?.data?.open_hours?.map((day, index) => {
                  return (
                    <p
                      key={index}
                      style={{
                        fontSize: 14,
                        fontWeight: 400,
                        marginBottom: 1,
                      }}
                    >
                      {" "}
                      <label>{day.dayName} : </label>{" "}
                      {day?.close === null ||
                      day?.close === "" ||
                      day?.open === null ||
                      day?.open === "" ? (
                        "Closed"
                      ) : (
                        <>
                          {day.open
                            ? moment(day.open, "hh:mm").format("hh:mm A")
                            : null}{" "}
                          -{" "}
                          {day.close
                            ? moment(day.close, "hh:mm").format("hh:mm A")
                            : null}{" "}
                        </>
                      )}
                    </p>
                  );
                })
              : null}
          </div>
        </div>
      </div>
      <div className="event-button-row submit">
        <button className="back-btn submit-btn" onClick={() => props.back()}>
          Back
        </button>
        <button
          className="next-btn submit-btn"
          onClick={() => props.next({}, true)}
        >
          {props.type === "edit" ? "Save changes" : "Publish"}
        </button>
      </div>
    </div>
  );
};

export default ReviewPublish;
